export default __webpack_public_path__ + "static/acai1-2d6264daaf596877412e3d1a48c35c77.png";